define([
    './_site',
    './window'
], function(
    Site,
    Wdw
) {
    var _self;
    // console.log('awards');

    // obj
    _self = {
        loadWinners: function ($el) {
            var $awards = $('#awards'),
                url = $awards.data('load-winners-action'),
                requestType = $awards.data('request'),
                sectionClass = 'section',
                cache = false,
                data = {
                    type: $el.data('load-winners')
                },
                flag = false,
                spinner = $.extend(true, {}, Site.spin);

            // loading
            $.extend(spinner, {
                color: '#000',
                top: '10%',
                // left: '0'
                width: 10,
                radius: 15
            });

            function toggleLoader(flag) {
                if (flag) {
                    // add loader
                    $awards.addClass(sectionClass + '--loading');
                    $awards.spin(spinner);
                    $awards.append($('#awards .spinner'));
                } else {
                    // remove loader
                    $awards.removeClass(sectionClass + '--loading');
                    $awards.spin(false);
                }
            }

            // update url using GET (Requested by AC)
            if(!requestType) {
                requestType = 'POST';
            }

            if(requestType.toLowerCase() == 'get') {
                url = url.concat((url[url.length - 1] != '/' ? '/' : '' ), $el.data('load-winners'));
                data = null;
                cache = true;
            }

            // send data
            $.ajax({
                type: requestType,
                url: url,
                data: data,
                cache: cache,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    toggleLoader(true);
                },
                success: function (response) {
                    console.log(response);

                    if (response.status) {
                        if (response.winners) {
                            $awards.replaceWith(response.winners);
                        }
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    toggleLoader(false);
                },
                error: function (response) {
                    // TODO
                    if (response.statusText == "abort") {
                        return;
                    }
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    toggleLoader(false);
                }
            });
        },
        selectEvent: function ($el) {
            var val = $el.val(),
                isRange = val.indexOf('range_') != -1,
                url = $el.data('select-event'),
                $selectYear = $('#awards-year-select'),
                awardsClass = 'awards-select',
                data = {
                    range: val.replace('range_', '')
                },
                flag = false,
                spinner = $.extend(true, {}, Site.spin);

            function toggleLoader(flag) {
                $selectYear.show();

                if (flag) {
                    // add loader
                    $selectYear.addClass(awardsClass + '--loading');
                    $selectYear.spin(spinner);
                } else {
                    // remove loader
                    $selectYear.removeClass(awardsClass + '--loading');
                    $selectYear.spin(false);
                }
            }

            // loading
            $.extend(spinner, {
                color: '#000',
                // top: '50%',
                // left: '0'
                // width: 10,
                // radius: 15
            });

            if (!isRange) {
                window.location.href = val;
                return;
            }

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    toggleLoader(true);
                },
                success: function (response) {
                    console.log(response);

                    if (response.status) {
                        if (response.select) {
                            $selectYear.replaceWith(response.select);
                        }
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    toggleLoader(false);
                },
                error: function (response) {
                    // TODO
                    if (response.statusText == "abort") {
                        return;
                    }
                    // create alert
                    Wdw.createAlert(response, 'error');
                    // remove loader
                    toggleLoader(false);
                }
            });
        },
        scrollToAwards: function ($el) {
            var $target = $($el.val()),
                breakpoints = Site.breakpoints,
                offset = 100;

            if ($(window).width() < breakpoints.md) {
                offset = null;
            }

            Wdw.scrollTo($target, offset);
        },
        changeListView: function ($el) {
            var type = $el.data('list-view'),
                $list = $('#awards-list'),
                activeClass = 'options-view__item--active';

            // set active trigger
            $el.siblings().removeClass(activeClass);
            $el.addClass(activeClass);

            // change list style
            $list.removeClass('grid list');
            $list.addClass(type);
        }
    };


    // -------------------
    // BINDS
    // -------------------


    // ---------------- load winners
    $('#content').on('click.awards', '[data-load-winners]', function (event) {
        event.preventDefault();
        _self.loadWinners($(this));
    });

    // ---------------- select event
    $('#content').on('change.awards', '[data-select-event]', function (event) {
        _self.selectEvent($(this));
    });

    // ---------------- change list view
    $('#content').on('click.awards', '[data-list-view]', function (event) {
        _self.changeListView($(this));
    });

    // ---------------- scroll to awards
    $('#content').on('change.awards', '[data-scrollto-award]', function (event) {
        _self.scrollToAwards($(this));
    });

    return _self;
});
